export default __webpack_public_path__ + "static/media/default-alblum-img.ea3dd2eb.png";